export const INTERNAL_PEOPLE_COPY = {
    TITLE: 'Internal people',
    CARD_PEOPLE: 'People',
    CARD_ON: 'On for new brands',
    CARD_OFF: 'Off for new brands',
    CAPTION_ALL: 'Everyone who signs in to this admin dashboard.',
    CAPTION_ALL_SEARCH: 'Internal people matching this search.',
    CAPTION_ON: 'List on new brands is on. Click to filter the list.',
    CAPTION_OFF: 'List on new brands is off. Click to filter the list.',
    CAPTION_FILTERING: 'Filtering the list. Click again to clear.',
    SEARCH_PLACEHOLDER: 'Search by name or phone',
    COL_NAME: 'Name',
    COL_PHONE: 'Phone',
    COL_LIST: 'List on new brands',
    TOOLTIP: 'Turning this on or off does not change the brands this person is already on.',
    TOOLTIP_LABEL: 'About List on new brands',
    IN_THE_LIST: 'in the list',
    PERSON: 'person',
    PEOPLE: 'people',
    EMPTY_TITLE: 'No internal people yet',
    EMPTY_BODY: 'People who sign in to this admin dashboard are listed here.',
    NO_MATCH_PREFIX: 'No one matches',
    NO_MATCH_BODY: 'Search looks at name and phone. Clear it to see everyone again.',
    FILTER_EMPTY_ON: 'No one in this search is on for new brands',
    FILTER_EMPTY_OFF: 'No one in this search is off for new brands',
    FILTER_EMPTY_BODY: 'The filter and the search together leave no one in the list.',
    CLEAR_SEARCH: 'Clear search',
    CLEAR_FILTER: 'Clear filter',
    CLEAR_FILTER_LABEL: 'Clear this filter',
    ERROR_TITLE: 'The internal people list could not be loaded',
    ERROR_BODY: 'Nothing in the list was changed. The summary cards above are not affected.',
    RETRY: 'Retry the list',
    SAVING: 'Saving',
    ROW_ERROR: 'List on new brands was not saved.',
    TRY_AGAIN: 'Try again',
} as const;
